import { TOptionTypeUi } from 'data/types/GeneralTypes';
import { EPropertyManagementUrls } from 'data/urls/propertyManagement.url';
import { authSplitApi } from 'redux/helpers/slice.helpers';

export const analyticsApi = authSplitApi('analytics', ['units']).injectEndpoints({
  endpoints: (build) => ({
    getUnitsAnalytics: build.query<
      number,
      { propertyManagementIds: TOptionTypeUi[]; propertyManagementStatuses: TOptionTypeUi[] }
    >({
      query({ propertyManagementIds, propertyManagementStatuses }) {
        return {
          url: `${EPropertyManagementUrls.ANALYTICS}/${EPropertyManagementUrls.UNITS}`,
          method: 'GET',
          params: {
            ...(propertyManagementIds.length && {
              propertyManagementIds: propertyManagementIds.map((item) => item.value),
            }),
            ...(propertyManagementStatuses.length && {
              propertyManagementStatuses: propertyManagementStatuses.map((item) => item.value),
            }),
          },
        };
      },
      providesTags: ['units'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetUnitsAnalyticsQuery } = analyticsApi;
